import React from "react";
import PropTypes from "prop-types";

import { formatKey } from "../../utils/commonUtils";

export const FilterChips = ({ filters, onRemove }) => {
    // Group filters by type
    const groupedFilters = filters.reduce((acc, filter) => {
        if (!acc[filter.type]) acc[filter.type] = [];
        acc[filter.type].push(filter);
        return acc;
    }, {});

    // Filter only for `audioType` and `status`
    const allowedTypes = ["audioType", "status"];

    return (
        <div className="filter-chips">
            {allowedTypes.map(
                (type) =>
                    groupedFilters[type] && (
                        <div key={type} className="filter-chip-group">
                            <strong>{formatKey(type)}:</strong>
                            {groupedFilters[type].map((filter, index) => (
                                <span
                                    key={`${filter.type}-${filter.label}-${index}`}
                                    className="filter-chip"
                                >
                                    {filter.label}
                                    <i
                                        className="bx bx-x filter-chip-remove"
                                        onClick={() => onRemove(filter.type, filter.value)}
                                    ></i>
                                    {index < groupedFilters[type].length - 1 && ", "}
                                </span>
                            ))}
                        </div>
                    )
            )}
        </div>
    );
};

FilterChips.propTypes = {
    filters: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired // `value` is a string, not an object
        })
    ).isRequired,
    onRemove: PropTypes.func.isRequired
};
